import React, { useState } from 'react';
import { func, object } from 'prop-types';
import Settings from 'components/ui/Settings';
import Checkbox from 'components/ui/Checkbox';
import Slider from 'components/ui/Slider';
import Help from 'components/ui/Help';
import SmallChart from 'components/ui/SmallChart';
import SliderLegend from 'components/ui/SliderLegend';
import { trayectoriasRetiroCarbon, trayectoriasElectromovilidad } from 'config';
import IntroERHelp from 'components/help/IntroERHelp';
import ElectrificacionTermicaIndustriaHelp from 'components/help/ElectrificacionTermicaIndustriaHelp';
import ReemplazoTransporteMineriaHelp from 'components/help/ReemplazoTransporteMineriaHelp';
import ElectrificacionACSResidencialHelp from 'components/help/ElectrificacionACSResidencialHelp';
import CalefaccionDistritalHelp from 'components/help/CalefaccionDistritalHelp';
import RetiroCentralesHelp from 'components/help/RetiroCentralesHelp';
import ElectromovilidadLivianoHelp from 'components/help/ElectromovilidadLivianoHelp';
import ElectromovilidadBusesHelp from 'components/help/ElectromovilidadBusesHelp';
import ERBajaTensionHelp from 'components/help/ERBajaTensionHelp';
import ElectrificacionCalefaccionResidencialHelp from 'components/help/ElectrificacionCalefaccionResidencialHelp';
import ReemplazoTransporteCargaHelp from 'components/help/ReemplazoTransporteCargaHelp';
import HidrogenoAereoHelp from 'components/help/HidrogenoAereoHelp';
import HidrogenoMotricesHelp from 'components/help/HidrogenoMotricesHelp';
import HidrogenoTermicoHelp from 'components/help/HidrogenoTermicoHelp';
import HidrogenoMaritimoHelp from 'components/help/HidrogenoMaritimoHelp';
import TeletrabajoHelp from 'components/help/TeletrabajoHelp';
import ElectrificacionFinalComercialHelp from 'components/help/ElectrificacionFinalComercialHelp';
import TransportePublicoHelp from 'components/help/TransportePublicoHelp';
import TransporteNoMotorizadoHelp from 'components/help/TransporteNoMotorizadoHelp';
import SolaresResidencialHelp from 'components/help/SolaresResidencialHelp';
import ElectrificacionIndustriaMineriaHelp from 'components/help/ElectrificacionIndustriaMineriaHelp';
import ElectrificacionCoccionMineriaHelp from 'components/help/ElectrificacionCoccionMineriaHelp';
import ReglamentacionTermicaViviendasHelp from 'components/help/ReglamentacionTermicaViviendasHelp';
import ElectromovilidadTaxisColectivosHelp from 'components/help/ElectromovilidadTaxisColectivosHelp';

/**
 * Opciones de configuración para las diferentes políticas energéticas, y la explicación de cada una. 
 */
const EnergeticPolicies = ({ settings, onChange }) => {

  // Nomenclatura frecuente -> primeras tres letras de cada palabra de una id
  const selectedTrayectoriaIntroHidroMin = settings.reemplazo_transporte_mineria.trayectoria || 1;
  //const selectedTrayectoriaID = settings.ID.trayectoria || 1;
  const selectedTrayectoriaHidroCam = settings.reemplazo_transporte_carga.trayectoria || 1; 
  const selectedTrayectoriaHidAer = settings.hidrogeno_aereo.trayectoria || 1; 
  const selectedTrayectoriaHidMar = settings.hidrogeno_maritimo.trayectoria || 1; 
  const selectedTrayectoriaHidMot = settings.hidrogeno_motrices.trayectoria || 1; 
  const selectedTrayectoriaHidTer = settings.hidrogeno_termico.trayectoria || 1; 
  const selectedTrayectoriaSolRes = settings.solares_residencial.trayectoria || 1; 
  const selectedTrayectoriaEleIndMin = settings.electrificacion_industria_mineria.trayectoria || 1; 
  const selectedTrayectoriaEleCalRes = settings.electrificacion_calefaccion_residencial.trayectoria || 1; 
  const selectedTrayectoriaEleCocMin = settings.electrificacion_coccion_mineria.trayectoria || 1; 
  const selectedTrayectoriaEleFinCom = settings.electrificacion_final_comercial.trayectoria || 1; 
  const selectedTrayectoriaRegTerViv = settings.reglamentacion_termica_viviendas.trayectoria || 1; 
  const selectedTrayectoriaTraPub = settings.transporte_publico.trayectoria || 1; 
  const selectedTrayectoriaTraNoMot = settings.transporte_no_motorizado.trayectoria || 1; 
  const selectedTrayectoriaTel = settings.teletrabajo.trayectoria || 1; 
  const selectedTrayectoriaEleTaxCol = settings.electromovilidad_taxis_y_colectivos.trayectoria || 1; 
  const selectedTrayectoriaIntroER = settings.introduccion_energias_renovables.trayectoria || 1;
  const selectedTrayectoriaReemplazo = settings.electrificacion_termica_industria.trayectoria || 1;
  const selectedTrayectoriaEficienciaTransp = settings.electrificacion_ACS_residencial.trayectoria || 1;
  const selectedTrayectoriaEficienciaMin = settings.calefaccion_distrital.trayectoria || 1;
  const selectedTrayectoriaRetiroCarbon = settings.retiro_centrales_carbon.trayectoria || 1;
  const selectedTrayectoriaElectromovilidad = settings.electromovilidad.trayectoria || 1;
  const selectedTrayectoriaEleBus = settings.electromovilidad_buses.trayectoria || 1;
  const selectedTrayectoriaEEBT = settings.introduccion_er_baja_tension.trayectoria || 1;

  const [introERVisible, setIntrodERVisible] = useState(true);
  const [eficienciaTranspVisible, setEficienciaTranspVisible] = useState(true);
  const [eficienciaMinVisible, setEficienciaMinVisible] = useState(true);
  const [retiroVisible, setRetiroVisible] = useState(true);
  const [electromovilidadVisible, setElectromovilidadVisible] = useState(true);
  const [eebtVisible, setEebtvisible] = useState(true);
  const [hidroCamVisible  , setHidroCamVisible] = useState(true);
  const [hidAerVisible    , setHidAerVisible] = useState(true);
  const [hidTraMin, setHidTraMinVisible] = useState(true);
  const [hidMarVisible    , setHidMarVisible] = useState(true);
  const [hidMotVisible    , setHidMotVisible] = useState(true);
  const [hidTerVisible    , setHidTerVisible] = useState(true);
  const [solResVisible    , setSolResVisible] = useState(true);
  const [eleIndMinVisible , setEleIndMinVisible] = useState(true);
  const [eleCalResVisible , setEleCalResVisible] = useState(true);
  const [eleCocMinVisible , setEleCocMinVisible] = useState(true);
  const [eleFinComVisible , setEleFinComVisible] = useState(true);
  const [regTerVivVisible , setRegTerVivVisible] = useState(true);
  const [traPubVisible    , setTraPubVisible] = useState(true);
  const [traNoMotVisible  , setTraNoMotVisible] = useState(true);
  const [telVisible       , setTelVisible] = useState(true);
  const [eleTaxColVisible , setEleTaxColVisible] = useState(true);
  const [reemplazoVisible , setReemplazoVisible] = useState(true);
  const [eleBusVisible   , setEleBusVisible] = useState(true);

  return (
    <Settings.Panel.Correct>
      <h4>Medidas de mitigación</h4>
      <Checkbox
        id="reemplazo_transporte_mineria"
        label="Reemplazo de tecnologías en transporte minero"
        checked={settings.reemplazo_transporte_mineria.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            reemplazo_transporte_mineria: {
              ...settings.reemplazo_transporte_mineria,
              enabled: true,
              trayectoria: selectedTrayectoriaIntroHidroMin,
            },
          }) : {
            reemplazo_transporte_mineria: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setHidTraMinVisible(value);
        }}
        visible={hidTraMin}
        enabled={settings.reemplazo_transporte_mineria.enabled}
        toggleVisible={() => {
          setHidTraMinVisible(!hidTraMin);
        }}
        help={<ReemplazoTransporteMineriaHelp />}
      />
      <Checkbox
        id="reemplazo_transporte_carga"
        label="Reemplazo de tecnologías en camiones de transporte de carga"
        checked={settings.reemplazo_transporte_carga.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            reemplazo_transporte_carga: {
              ...settings.reemplazo_transporte_carga,
              enabled: true,
              trayectoria: selectedTrayectoriaHidroCam,
            },
          }) : {
            reemplazo_transporte_carga: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setHidroCamVisible(value); 
        }}
        visible={hidroCamVisible}
        enabled={settings.reemplazo_transporte_carga.enabled}
        toggleVisible={() => {
          setHidroCamVisible(!hidroCamVisible);
        }}
        help={<ReemplazoTransporteCargaHelp />} //[ID].Help
      />
      <Checkbox
        id="hidrogeno_aereo"
        label="Hidrógeno en transporte aéreo"
        checked={settings.hidrogeno_aereo.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            hidrogeno_aereo: {
              ...settings.hidrogeno_aereo,
              enabled: true,
              trayectoria: selectedTrayectoriaHidAer,
            },
          }) : {
            hidrogeno_aereo: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setHidAerVisible(hidAerVisible); 
        }}
        visible={hidAerVisible}
        enabled={settings.hidrogeno_aereo.enabled}
        toggleVisible={() => {
          setHidAerVisible(!hidAerVisible);
        }}
        help={<HidrogenoAereoHelp />} //hidrogeno_aereo.Help
      />
      <Checkbox
        id="hidrogeno_maritimo"
        label="Hidrógeno en transporte marítimo"
        checked={settings.hidrogeno_maritimo.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            hidrogeno_maritimo: {
              ...settings.hidrogeno_maritimo,
              enabled: true,
              trayectoria: selectedTrayectoriaHidMar,
            },
          }) : {
            hidrogeno_maritimo: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setHidMarVisible(value); 
        }}
        visible={hidMarVisible}
        enabled={settings.hidrogeno_maritimo.enabled}
        toggleVisible={() => {
          setHidMarVisible(!hidMarVisible);
        }}
        help={<HidrogenoMaritimoHelp />} //hidrogeno_maritimo.Help
      />
       <Checkbox
        id="hidrogeno_motrices"
        label="Hidrógeno para usos motrices en industria y minería"
        checked={settings.hidrogeno_motrices.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            hidrogeno_motrices: {
              ...settings.hidrogeno_motrices,
              enabled: true,
              trayectoria: selectedTrayectoriaHidMot,
            },
          }) : {
            hidrogeno_motrices: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setHidMotVisible(value); 
        }}
        visible={hidMotVisible}
        enabled={settings.hidrogeno_motrices.enabled}
        toggleVisible={() => {
          setHidMotVisible(!hidMotVisible);
        }}
        help={<HidrogenoMotricesHelp />} //hidrogeno_motrices.Help
      />
      {
        settings.hidrogeno_motrices.enabled && hidMotVisible && (
          <Settings.Options>
            <label>
              Trayectoria de Hidrógeno para usos motrices en industria y minería
            </label>
            <Slider
              value={selectedTrayectoriaHidMot}
              min={1}
              max={2}
              step={1}
              onChange={(e, value) => {
                onChange({
                  ...settings,
                  hidrogeno_motrices: {
                    ...settings.hidrogeno_motrices,
                    trayectoria: value,
                  },
                })
              }}
            />
            <SliderLegend
              options={[
                {
                  label: 'Tray. 1',
                  value: 1,
                },
                {
                  label: 'Tray. 2',
                  value: 2,
                },
              ]}
              onChange={(value) => {
                onChange({
                  ...settings,
                  hidrogeno_motrices: {
                    ...settings.hidrogeno_motrices,
                    trayectoria: value,
                  },
                })
              }}
            />
          </Settings.Options>
        )
      }
       <Checkbox
        id="hidrogeno_termico"
        label="Hidrógeno para usos térmicos en industria y minería"
        checked={settings.hidrogeno_termico.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            hidrogeno_termico: {
              ...settings.hidrogeno_termico,
              enabled: true,
              trayectoria: selectedTrayectoriaHidTer,
            },
          }) : {
            hidrogeno_termico: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setHidTerVisible(value); 
        }}
        visible={hidTerVisible}
        enabled={settings.hidrogeno_termico.enabled}
        toggleVisible={() => {
          setHidTerVisible(!hidTerVisible);
        }}
        help={<HidrogenoTermicoHelp />} //hidrogeno_termico.Help
      />
      <Checkbox
        id="electrificacion_termica_industria"
        label="Electrificación de usos térmicos en industria y minería"
        checked={settings.electrificacion_termica_industria.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            electrificacion_termica_industria: {
              ...settings.electrificacion_termica_industria,
              enabled: true,
              trayectoria: selectedTrayectoriaReemplazo,
            },
          }) : {
            electrificacion_termica_industria: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setIntrodERVisible(value);
        }}
        visible={reemplazoVisible}
        enabled={settings.electrificacion_termica_industria.enabled}
        toggleVisible={() => {
          setReemplazoVisible(!reemplazoVisible);
        }}
        help={<ElectrificacionTermicaIndustriaHelp />}
      />
      {
        settings.electrificacion_termica_industria.enabled && reemplazoVisible && (
          <Settings.Options>
            <label>
              Trayectoria de Introducción E.R. en procesos productivos
            </label>
            <Slider
              value={selectedTrayectoriaReemplazo}
              min={1}
              max={2}
              step={1}
              onChange={(e, value) => {
                onChange({
                  ...settings,
                  electrificacion_termica_industria: {
                    ...settings.electrificacion_termica_industria,
                    trayectoria: value,
                  },
                })
              }}
            />
            <SliderLegend
              options={[
                {
                  label: 'Tray. 1',
                  value: 1,
                },
                {
                  label: 'Tray. 2',
                  value: 2,
                },
              ]}
              onChange={(value) => {
                onChange({
                  ...settings,
                  electrificacion_termica_industria: {
                    ...settings.electrificacion_termica_industria,
                    trayectoria: value,
                  },
                })
              }}
            />
          </Settings.Options>
        )
      }
      <Checkbox
        id="introduccion_energias_renovables"
        label="Sistemas solares térmicos en industria y minería"
        checked={settings.introduccion_energias_renovables.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            introduccion_energias_renovables: {
              ...settings.introduccion_energias_renovables,
              enabled: true,
              trayectoria: selectedTrayectoriaIntroER,
            },
          }) : {
            introduccion_energias_renovables: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setIntrodERVisible(value);
        }}
        visible={introERVisible}
        enabled={settings.introduccion_energias_renovables.enabled}
        toggleVisible={() => {
          setIntrodERVisible(!introERVisible);
        }}
        help={<IntroERHelp />}
      />
      {
        settings.introduccion_energias_renovables.enabled && introERVisible && (
          <Settings.Options>
            <label>
              Trayectoria de Introducción E.R. en procesos productivos
            </label>
            <Slider
              value={selectedTrayectoriaIntroER}
              min={1}
              max={2}
              step={1}
              onChange={(e, value) => {
                onChange({
                  ...settings,
                  introduccion_energias_renovables: {
                    ...settings.introduccion_energias_renovables,
                    trayectoria: value,
                  },
                })
              }}
            />
            <SliderLegend
              options={[
                {
                  label: 'Tray. 1',
                  value: 1,
                },
                {
                  label: 'Tray. 2',
                  value: 2,
                },
              ]}
              onChange={(value) => {
                onChange({
                  ...settings,
                  introduccion_energias_renovables: {
                    ...settings.introduccion_energias_renovables,
                    trayectoria: value,
                  },
                })
              }}
            />
          </Settings.Options>
        )
      }
      <Checkbox
        id="solares_residencial"
        label="Sistemas solares térmicos en sector residencial"
        checked={settings.solares_residencial.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            solares_residencial: {
              ...settings.solares_residencial,
              enabled: true,
              trayectoria: selectedTrayectoriaSolRes,
            },
          }) : {
            solares_residencial: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setSolResVisible(value); 
        }}
        visible={solResVisible}
        enabled={settings.solares_residencial.enabled}
        toggleVisible={() => {
          setSolResVisible(!solResVisible);
        }}
        help={<SolaresResidencialHelp />} //solares_residencial.Help
      />
      {
        settings.solares_residencial.enabled && solResVisible && (
          <Settings.Options>
            <label>
              Trayectoria de Sistema solares térmicos en sector residencial
            </label>
            <Slider
              value={selectedTrayectoriaSolRes}
              min={1}
              max={2}
              step={1}
              onChange={(e, value) => {
                onChange({
                  ...settings,
                  solares_residencial: {
                    ...settings.solares_residencial,
                    trayectoria: value,
                  },
                })
              }}
            />
            <SliderLegend
              options={[
                {
                  label: 'Tray. 1',
                  value: 1,
                },
                {
                  label: 'Tray. 2',
                  value: 2,
                },
              ]}
              onChange={(value) => {
                onChange({
                  ...settings,
                  solares_residencial: {
                    ...settings.solares_residencial,
                    trayectoria: value,
                  },
                })
              }}
            />
          </Settings.Options>
        )
      }
      <Checkbox
        id="electrificacion_industria_mineria"
        label="Electrificación de usos motrices en industria y minería"
        checked={settings.electrificacion_industria_mineria.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            electrificacion_industria_mineria: {
              ...settings.electrificacion_industria_mineria,
              enabled: true,
              trayectoria: selectedTrayectoriaEleIndMin,
            },
          }) : {
            electrificacion_industria_mineria: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setEleIndMinVisible(value); 
        }}
        visible={eleIndMinVisible}
        enabled={settings.electrificacion_industria_mineria.enabled}
        toggleVisible={() => {
          setEleIndMinVisible(!eleIndMinVisible);
        }}
        help={<ElectrificacionIndustriaMineriaHelp />} //electrificacion_industria_mineria.Help
      />
      {
        settings.electrificacion_industria_mineria.enabled && eleIndMinVisible && (
          <Settings.Options>
            <label>
              Trayectoria de Electrificación de usos motrices en industria y minería 
            </label>
            <Slider
              value={selectedTrayectoriaEleIndMin}
              min={1}
              max={2}
              step={1}
              onChange={(e, value) => {
                onChange({
                  ...settings,
                  electrificacion_industria_mineria: {
                    ...settings.electrificacion_industria_mineria,
                    trayectoria: value,
                  },
                })
              }}
            />
            <SliderLegend
              options={[
                {
                  label: 'Tray. 1',
                  value: 1,
                },
                {
                  label: 'Tray. 2',
                  value: 2,
                },
              ]}
              onChange={(value) => {
                onChange({
                  ...settings,
                  electrificacion_industria_mineria: {
                    ...settings.electrificacion_industria_mineria,
                    trayectoria: value,
                  },
                })
              }}
            />
          </Settings.Options>
        )
      }
      <Checkbox
        id="electrificacion_calefaccion_residencial"
        label="Electrificación de calefacción en sector residencial"
        checked={settings.electrificacion_calefaccion_residencial.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            electrificacion_calefaccion_residencial: {
              ...settings.electrificacion_calefaccion_residencial,
              enabled: true,
              trayectoria: selectedTrayectoriaEleCalRes,
            },
          }) : {
            electrificacion_calefaccion_residencial: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setEleCalResVisible(value); 
        }}
        visible={eleCalResVisible}
        enabled={settings.electrificacion_calefaccion_residencial.enabled}
        toggleVisible={() => {
          setEleCalResVisible(!eleCalResVisible);
        }}
        help={<ElectrificacionCalefaccionResidencialHelp />} //electrificacion_calefaccion_residencial.Help
      />
      <Checkbox
        id="electrificacion_coccion_mineria"
        label="Electrificación de cocción en sector residencial"
        checked={settings.electrificacion_coccion_mineria.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            electrificacion_coccion_mineria: {
              ...settings.electrificacion_coccion_mineria,
              enabled: true,
              trayectoria: selectedTrayectoriaEleCocMin,
            },
          }) : {
            electrificacion_coccion_mineria: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setEleCocMinVisible(value); 
        }}
        visible={eleCocMinVisible}
        enabled={settings.electrificacion_coccion_mineria.enabled}
        toggleVisible={() => {
          setEleCocMinVisible(!eleCocMinVisible);
        }}
        help={<ElectrificacionCoccionMineriaHelp />} //electrificacion_coccion_mineria.Help
      />
      <Checkbox
        id="electrificacion_final_comercial"
        label="Electrificación de usos finales en sector comercial"
        checked={settings.electrificacion_final_comercial.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            electrificacion_final_comercial: {
              ...settings.electrificacion_final_comercial,
              enabled: true,
              trayectoria: selectedTrayectoriaEleFinCom,
            },
          }) : {
            electrificacion_final_comercial: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setEleFinComVisible(value); 
        }}
        visible={eleFinComVisible}
        enabled={settings.electrificacion_final_comercial.enabled}
        toggleVisible={() => {
          setEleFinComVisible(!eleFinComVisible);
        }}
        help={<ElectrificacionFinalComercialHelp />} //electrificacion_final_comercial.Help
      />
      {
        settings.electrificacion_final_comercial.enabled && eleFinComVisible && (
          <Settings.Options>
            <label>
              Trayectoria de Electrificación de usos finales en sector comercial
            </label>
            <Slider
              value={selectedTrayectoriaEleFinCom}
              min={1}
              max={2}
              step={1}
              onChange={(e, value) => {
                onChange({
                  ...settings,
                  electrificacion_final_comercial: {
                    ...settings.electrificacion_final_comercial,
                    trayectoria: value,
                  },
                })
              }}
            />
            <SliderLegend
              options={[
                {
                  label: 'Tray. 1',
                  value: 1,
                },
                {
                  label: 'Tray. 2',
                  value: 2,
                },
              ]}
              onChange={(value) => {
                onChange({
                  ...settings,
                  electrificacion_final_comercial: {
                    ...settings.electrificacion_final_comercial,
                    trayectoria: value,
                  },
                })
              }}
            />
          </Settings.Options>
        )
      }
      <Checkbox
        id="electrificacion_ACS_residencial"
        label="Electrificación de agua caliente sanitaria (ACS) en sector residencial"
        checked={settings.electrificacion_ACS_residencial.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            electrificacion_ACS_residencial: {
              ...settings.electrificacion_ACS_residencial,
              enabled: true,
              trayectoria: selectedTrayectoriaEficienciaTransp,
            },
          }) : {
            electrificacion_ACS_residencial: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setEficienciaTranspVisible(value);
        }}
        visible={eficienciaTranspVisible}
        enabled={settings.electrificacion_ACS_residencial.enabled}
        toggleVisible={() => {
          setEficienciaTranspVisible(!eficienciaTranspVisible);
        }}
        help={<ElectrificacionACSResidencialHelp />}
      />
      <Checkbox
        id="calefaccion_distrital"
        label="Energía distrital"
        checked={settings.calefaccion_distrital.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            calefaccion_distrital: {
              ...settings.calefaccion_distrital,
              enabled: true,
              trayectoria: selectedTrayectoriaEficienciaMin,
            },
          }) : {
            calefaccion_distrital: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setEficienciaMinVisible(value);
        }}
        visible={eficienciaMinVisible}
        enabled={settings.calefaccion_distrital.enabled}
        toggleVisible={() => {
          setEficienciaMinVisible(!eficienciaMinVisible);
        }}
        help={<CalefaccionDistritalHelp />}
      />
      <Checkbox
        id="reglamentacion_termica_viviendas"
        label="Mejoras en la reglamentación térmica de viviendas"
        checked={settings.reglamentacion_termica_viviendas.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            reglamentacion_termica_viviendas: {
              ...settings.reglamentacion_termica_viviendas,
              enabled: true,
              trayectoria: selectedTrayectoriaRegTerViv,
            },
          }) : {
            reglamentacion_termica_viviendas: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setRegTerVivVisible(value); 
        }}
        visible={regTerVivVisible}
        enabled={settings.reglamentacion_termica_viviendas.enabled}
        toggleVisible={() => {
          setRegTerVivVisible(!regTerVivVisible);
        }}
        help={<ReglamentacionTermicaViviendasHelp />} //reglamentacion_termica_viviendas.Help
      />
      <Checkbox
        id="transporte_publico"
        label="Fomento al transporte público"
        checked={settings.transporte_publico.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            transporte_publico: {
              ...settings.transporte_publico,
              enabled: true,
              trayectoria: selectedTrayectoriaTraPub,
            },
          }) : {
            transporte_publico: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setTraPubVisible(value); 
        }}
        visible={traPubVisible}
        enabled={settings.transporte_publico.enabled}
        toggleVisible={() => {
          setTraPubVisible(!traPubVisible);
        }}
        help={<TransportePublicoHelp />} //transporte_publico.Help
      />
      <Checkbox
        id="transporte_no_motorizado"
        label="Transporte no motorizado"
        checked={settings.transporte_no_motorizado.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            transporte_no_motorizado: {
              ...settings.transporte_no_motorizado,
              enabled: true,
              trayectoria: selectedTrayectoriaTraNoMot,
            },
          }) : {
            transporte_no_motorizado: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setTraNoMotVisible(value); 
        }}
        visible={traNoMotVisible}
        enabled={settings.transporte_no_motorizado.enabled}
        toggleVisible={() => {
          setTraNoMotVisible(!traNoMotVisible);
        }}
        help={<TransporteNoMotorizadoHelp />} //transporte_no_motorizado.Help
      />
      <Checkbox
        id="teletrabajo"
        label="Teletrabajo"
        checked={settings.teletrabajo.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            teletrabajo: {
              ...settings.teletrabajo,
              enabled: true,
              trayectoria: selectedTrayectoriaTel,
            },
          }) : {
            teletrabajo: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setTelVisible(value); 
        }}
        visible={telVisible}
        enabled={settings.teletrabajo.enabled}
        toggleVisible={() => {
          setTelVisible(!telVisible);
        }}
        help={<TeletrabajoHelp />} //teletrabajo.Help
      />
      {
        settings.teletrabajo.enabled && telVisible && (
          <Settings.Options>
            <label>
              Trayectoria de Teletrabajo
            </label>
            <Slider
              value={selectedTrayectoriaTel}
              min={1}
              max={2}
              step={1}
              onChange={(e, value) => {
                onChange({
                  ...settings,
                  teletrabajo: {
                    ...settings.teletrabajo,
                    trayectoria: value,
                  },
                })
              }}
            />
            <SliderLegend
              options={[
                {
                  label: 'Tray. 1',
                  value: 1,
                },
                {
                  label: 'Tray. 2',
                  value: 2,
                },
              ]}
              onChange={(value) => {
                onChange({
                  ...settings,
                  teletrabajo: {
                    ...settings.teletrabajo,
                    trayectoria: value,
                  },
                })
              }}
            />
          </Settings.Options>
        )
      }
      <Checkbox
        id="electromovilidad"
        label="Electromovilidad vehículos livianos"
        checked={settings.electromovilidad.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            electromovilidad: {
              ...settings.electromovilidad,
              enabled: true,
              trayectoria: selectedTrayectoriaElectromovilidad,
            },
          }) : {
            electromovilidad: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setElectromovilidadVisible(value);
        }}
        toggleVisible={() => {
          setElectromovilidadVisible(!electromovilidadVisible);
        }}
        enabled={settings.electromovilidad.enabled}
        visible={electromovilidadVisible}
        help={<ElectromovilidadLivianoHelp />}
      />
      {
        settings.electromovilidad.enabled && electromovilidadVisible && (
          <Settings.Options>
            <Help title={(
                <label>
                  Trayectoria de electromovilidad
                </label>
              )}>
                <SmallChart
                  id="tray_electromovilidad"
                  info="Porcentaje de participación de  vehículos eléctricos"
                  data={trayectoriasElectromovilidad.find(item => item.value === selectedTrayectoriaElectromovilidad)}
                />
            </Help>
            <Slider
              value={selectedTrayectoriaElectromovilidad}
              min={1}
              max={2}
              step={1}
              onChange={(e, value) => {
                onChange({
                  ...settings,
                  electromovilidad: {
                    ...settings.electromovilidad,
                    trayectoria: value,
                  },
                })
              }}
            />
            <SliderLegend
              options={[
                {
                  label: 'Tray. 1',
                  value: 1,
                },
                {
                  label: 'Tray. 2',
                  value: 2,
                },
              ]}
              onChange={(value) => {
                onChange({
                  ...settings,
                  electromovilidad: {
                    ...settings.electromovilidad,
                    trayectoria: value,
                  },
                })
              }}
            />
          </Settings.Options>
        )
      }
      <Checkbox
        id="electromovilidad_taxis_y_colectivos"
        label="Electromovilidad en taxis y colectivos"
        checked={settings.electromovilidad_taxis_y_colectivos.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            electromovilidad_taxis_y_colectivos: {
              ...settings.electromovilidad_taxis_y_colectivos,
              enabled: true,
              trayectoria: selectedTrayectoriaEleTaxCol,
            },
          }) : {
            electromovilidad_taxis_y_colectivos: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setEleTaxColVisible(value); 
        }}
        visible={eleTaxColVisible}
        enabled={settings.electromovilidad_taxis_y_colectivos.enabled}
        toggleVisible={() => {
          setEleTaxColVisible(!eleTaxColVisible);
        }}
        help={<ElectromovilidadTaxisColectivosHelp />} //electromovilidad_taxis_y_colectivos.Help
      />
       <Checkbox
        id="electromovilidad_buses"
        label="Electromovilidad en buses"
        checked={settings.electromovilidad_buses.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            electromovilidad_buses: {
              ...settings.electromovilidad_buses,
              enabled: true,
              trayectoria: selectedTrayectoriaEleBus,
            },
          }) : {
            electromovilidad_buses: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setEleBusVisible(value);
        }}
        toggleVisible={() => {
          setEleBusVisible(!eleBusVisible);
        }}
        enabled={settings.electromovilidad_buses.enabled}
        visible={eleBusVisible}
        help={<ElectromovilidadBusesHelp />}
      />
      <Checkbox
        id="introduccion_er_baja_tension"
        label="Introducción de energías renovables en baja tensión"
        checked={settings.introduccion_er_baja_tension.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            introduccion_er_baja_tension: {
              ...settings.introduccion_er_baja_tension,
              enabled: true,
              trayectoria: selectedTrayectoriaEEBT,
            },
          }) : {
            introduccion_er_baja_tension: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setEebtvisible(value);
        }}
        toggleVisible={() => {
          setEebtvisible(!eebtVisible);
        }}
        enabled={settings.introduccion_er_baja_tension.enabled}
        visible={eebtVisible}
        help={<ERBajaTensionHelp />}
      />
      {
        settings.introduccion_er_baja_tension.enabled && eebtVisible && (
          <Settings.Options>
            <Help title={(
              <label>
                Trayectoria de Introducción Energías Renovables en baja Tensión
              </label>
            )}>
              <SmallChart
                id="introduccion_er_baja_tension"
                info="Potencia instalada paneles solares fotovoltaicos."
              />
            </Help>
            <Slider
              value={selectedTrayectoriaEEBT}
              min={1}
              max={2}
              step={1}
              onChange={(e, value) => {
                onChange({
                  ...settings,
                  introduccion_er_baja_tension: {
                    ...settings.introduccion_er_baja_tension,
                    trayectoria: value,
                  },
                })
              }}
            />
            <SliderLegend
              options={[
                {
                  label: 'Tray. 1',
                  value: 1,
                },
                {
                  label: 'Tray. 2',
                  value: 2,
                },
              ]}
              onChange={(value) => {
                onChange({
                  ...settings,
                  introduccion_er_baja_tension: {
                    ...settings.introduccion_er_baja_tension,
                    trayectoria: value,
                  },
                })
              }}
            />
          </Settings.Options>
        )
      }
      <Checkbox
        id="retiro_centrales_carbon"
        label="Retiro de centrales a carbón"
        checked={settings.retiro_centrales_carbon.enabled}
        onChange={(e, value) => {
          const newValue = value ? ({
            retiro_centrales_carbon: {
              ...settings.retiro_centrales_carbon,
              enabled: true,
              trayectoria: selectedTrayectoriaRetiroCarbon,
            },
          }) : {
            retiro_centrales_carbon: {
              enabled: false,
            },
          }
          onChange({
            ...settings,
            ...newValue,
          });
          setRetiroVisible(value);
        }}
        toggleVisible={() => {
          setRetiroVisible(!retiroVisible);
        }}
        enabled={settings.retiro_centrales_carbon.enabled}
        visible={retiroVisible}
        help={<RetiroCentralesHelp />}
      />
      {
        settings.retiro_centrales_carbon.enabled && retiroVisible && (
          <Settings.Options>
            <Help title={(
                <label>
                  Trayectoria de retiro de centrales
                </label>
              )}>
                <SmallChart
                  id="tray_retiro_centrales"
                  info="Potencia instalada centrales a carbón."
                  data={trayectoriasRetiroCarbon.find(item => item.value === selectedTrayectoriaRetiroCarbon)}
                />
            </Help>
            <Slider
              value={selectedTrayectoriaRetiroCarbon}
              min={1}
              max={2}
              step={1}
              onChange={(e, value) => {
                onChange({
                  ...settings,
                  retiro_centrales_carbon: {
                    ...settings.retiro_centrales_carbon,
                    trayectoria: value,
                  },
                })
              }}
            />
            <SliderLegend
              options={[
                {
                  label: 'Tray. 1',
                  value: 1,
                },
                {
                  label: 'Tray. 2',
                  value: 2,
                },
              ]}
              onChange={(value) => {
                onChange({
                  ...settings,
                  retiro_centrales_carbon: {
                    ...settings.retiro_centrales_carbon,
                    trayectoria: value,
                  },
                })
              }}
            />
          </Settings.Options>
        )
      }
      
     
      
      
      
      
    </Settings.Panel.Correct>
  );
}

EnergeticPolicies.propTypes = {
  onChange: func,
  settings: object,
};

export default EnergeticPolicies;
